import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Alert,
  Modal,
  ConfigProvider,
  Table,
  Tag,
  Typography,
  Avatar,
  Form,
  Select,
  Input,
  Image,
} from "antd";
import { DownOutlined, EnterOutlined, WarningFilled } from "@ant-design/icons";
import Text from "../../components/Text/Text";
import _ from "lodash";
import "./CODiscountClass.css";
import Button from "../../components/Button/Button";
import { FlexCol } from "../../components/Container/Container";
import dayjs from "dayjs";
import { numberFormatter } from "../../utility/Formatter";
import { color, image } from "../../resource";
import { useMessageContext } from "../../context/MessageProvider";
import {
  updateStatusMainWithRemark,
  updateStatusShopWithRemark,
} from "../../datasource/CODiscountDatasource";
import axios, { AxiosRequestConfig } from "axios";

export const DetailDuplicateModal = ({
  dataDup,
  open,
  setOpen,
  isStatus,
  coType,
}: {
  dataDup: any;
  open: boolean;
  setOpen: (open: boolean) => void;
  isStatus?: boolean;
  coType?: string;
}) => {
  const [tab, setTab] = useState<("percent" | "bath")[]>(["percent", "bath"]);
  const [dataTab, setDataTab] = useState<any>("percent");
  const findPercent = dataDup.filter((item: any) => item.type === "BILL_PCT");
  const findBaht = dataDup.filter((item: any) => item.type === "SKU");
  const groupPercent = Object.values(
    _.groupBy(findPercent, (item) => item?.shops?.customerCompanyId),
  );
  const groupBaht = Object.values(_.groupBy(findBaht, (item) => item?.shops?.customerCompanyId));

  useEffect(() => {
    setTab(() => {
      if (groupPercent.length > 0 && groupBaht.length > 0) {
        return ["percent", "bath"];
      } else if (groupPercent.length > 0) {
        return ["percent"];
      } else if (groupBaht.length > 0) {
        return ["bath"];
      } else {
        return [];
      }
    });
    setDataTab(() => {
      if (groupPercent.length > 0) {
        return "percent";
      } else if (groupBaht.length > 0) {
        return "bath";
      } else {
        return "";
      }
    });
  }, [dataDup]);

  return (
    <Modal
      className='custom-ant-modal-duplicate'
      maskClosable={false}
      open={open}
      onCancel={() => setOpen(false)}
      centered
      footer={null}
      width={1100}
      bodyStyle={{ maxHeight: "80vh", overflowY: "auto", padding: 0 }}
    >
      <div
        style={{
          borderRadius: "8px",
          padding: "20px 24px",
          position: "sticky",
          top: 0,
          zIndex: 10,
          backgroundColor: "#fff",
        }}
      >
        <Text fontWeight={600} level={4}>
          ร้านค้าที่มีส่วนลดซ้ำ
        </Text>
        <br />
        {isStatus ? (
          <>
            <Text color='Text3'>
              • กรณีประเภทส่วนลด <b>% ของยอดบิล</b> จะไม่สามารถเปิดใช้งานได้
              หากต้องการให้ร้านค้าเริ่มใช้ส่วนลดนี้ กรุณาไปปิดใช้งานรายการเดิมของร้านนั้นก่อน{" "}
            </Text>
            <br />
            <Text color='Text3'>
              • กรณีประเภทส่วนลด <b>฿/หน่วย</b> ดำเนินการต่อได้
              แต่ส่วนลดของสินค้าดังกล่าวจะทำงานทับซ้อนกัน
            </Text>
          </>
        ) : (
          <Text level={6} color='Text3'>
            หากดำเนินการต่อ ส่วนลดของสินค้าดังกล่าวจะทำงานทับซ้อนกัน
          </Text>
        )}
        <>
          {tab.length > 1 && (
            <Row style={{ paddingTop: "8px" }} gutter={8} justify={"start"}>
              {tab.includes("percent") && (
                <Col>
                  <Button
                    typeButton={dataTab === "percent" ? "primary" : "primary-light"}
                    title={"% ของยอดบิล"}
                    height={40}
                    onClick={() => setDataTab("percent")}
                  />
                </Col>
              )}
              {tab.includes("bath") && (
                <Col>
                  <Button
                    typeButton={dataTab === "bath" ? "primary" : "primary-light"}
                    title={"บาท (฿)/หน่วย"}
                    height={40}
                    onClick={() => setDataTab("bath")}
                  />
                </Col>
              )}
            </Row>
          )}
        </>
      </div>
      <>
        {dataTab === "percent" && (
          <>
            {groupPercent.map((item: any, index: number) => (
              <React.Fragment key={index}>
                <Alert
                  key={index}
                  type={item[0].blocking ? "error" : "warning"}
                  style={{
                    borderRadius: "0px",
                    border: "none",
                    borderLeft: `${isStatus ? "4px solid #F24040" : "4px solid #2f80ed"}`,
                    backgroundColor: `${isStatus ? "#FEF0F0" : "#FEF1E7"}`,
                  }}
                  icon={<WarningFilled />}
                  showIcon
                  message={
                    <>
                      <Text level={6} color='Text3' fontWeight={600}>
                        ชื่อร้านค้า:
                      </Text>{" "}
                      <Text level={6} fontWeight={600}>
                        {item[0]?.shops?.customerName}
                      </Text>{" "}
                      &nbsp;&nbsp;
                      <Text level={6} color='Text3' fontWeight={600}>
                        จำนวนส่วนลดที่ซ้ำ:
                      </Text>{" "}
                      <Text level={6} fontWeight={600}>
                        {item.length} รายการ
                      </Text>
                    </>
                  }
                />
                <div style={{ padding: "10px 24px" }}>
                  <ConfigProvider
                    theme={{
                      components: {
                        Table: {
                          headerBg: "#F3F6F9",
                          fontFamily: "IBM Plex Sans Thai",
                          fontSize: 15,
                          rowHoverBg: "none",
                        },
                      },
                    }}
                  >
                    <Table
                      size='small'
                      columns={[
                        {
                          title: "รายการส่วนลด",
                          dataIndex: "name",
                          key: "name",
                          render: (value: any, row: any, index: number) => {
                            return {
                              children: (
                                <FlexCol>
                                  <Text>{value}</Text>
                                  <Text level={6} color='Text3'>
                                    {row?.code} • {dayjs(row?.startDate).format("DD/MM/YYYY")} -{" "}
                                    {dayjs(row?.endDate).format("DD/MM/YYYY")}
                                  </Text>
                                </FlexCol>
                              ),
                            };
                          },
                        },
                        {
                          title: "ประเภทส่วนลด",
                          dataIndex: "type",
                          key: "type",
                          render: (value: any, row: any, index: number) => {
                            return {
                              children: (
                                <FlexCol>
                                  <Tag
                                    style={{
                                      backgroundColor: `${row?.creditMemoType?.color}20`,
                                      border: "none",
                                    }}
                                  >
                                    <Typography.Text
                                      style={{
                                        color: row?.creditMemoType?.color,
                                        fontFamily: "IBM Plex Sans Thai",
                                        fontSize: 15,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {row?.creditMemoType?.code} • {row?.creditMemoType?.nameTh}
                                    </Typography.Text>
                                  </Tag>
                                </FlexCol>
                              ),
                            };
                          },
                        },
                        {
                          title: "วิธีคิดส่วนลด",
                          dataIndex: "type",
                          key: "type",
                          render: (value: any, row: any, index: number) => {
                            return {
                              children: (
                                <FlexCol>
                                  <Text>
                                    {value === "BILL_PCT" ? "% ของยอดบิล" : "บาท (฿)/หน่วย"}
                                  </Text>
                                </FlexCol>
                              ),
                            };
                          },
                        },
                        {
                          title: "ส่วนลด",
                          dataIndex: "discountPct",
                          key: "discountPct",
                          render: (value: any, row: any, index: number) => {
                            return {
                              children: (
                                <FlexCol>
                                  <Text>{numberFormatter(row?.shops?.discountPct)} %</Text>
                                </FlexCol>
                              ),
                            };
                          },
                        },
                      ]}
                      dataSource={item}
                      pagination={false}
                    />
                  </ConfigProvider>
                </div>
              </React.Fragment>
            ))}
          </>
        )}
        {dataTab === "bath" && (
          <>
            {groupBaht.map((item: any, index: number) => (
              <React.Fragment key={index}>
                <Alert
                  key={index}
                  type='warning'
                  style={{
                    borderRadius: "0px",
                    border: "none",
                    borderLeft: "4px solid #2f80ed",
                    backgroundColor: "#FEF1E7",
                  }}
                  icon={<WarningFilled />}
                  showIcon
                  message={
                    <>
                      <Text level={6} color='Text3' fontWeight={600}>
                        ชื่อร้านค้า:
                      </Text>{" "}
                      <Text level={6} fontWeight={600}>
                        {item[0]?.shops?.customerName}
                      </Text>{" "}
                      &nbsp;&nbsp;
                      <Text level={6} color='Text3' fontWeight={600}>
                        จำนวนส่วนลดที่ซ้ำ:
                      </Text>{" "}
                      <Text level={6} fontWeight={600}>
                        {item.length} รายการ
                      </Text>
                    </>
                  }
                />
                <div style={{ padding: "10px 24px" }}>
                  <ConfigProvider
                    theme={{
                      components: {
                        Table: {
                          headerBg: "#F3F6F9",
                          fontFamily: "IBM Plex Sans Thai",
                          fontSize: 15,
                          rowHoverBg: "none",
                        },
                      },
                    }}
                  >
                    <Table
                      size='small'
                      columns={[
                        {
                          title: "รายการส่วนลด",
                          dataIndex: "name",
                          key: "name",
                          render: (value: any, row: any, index: number) => {
                            return {
                              children: (
                                <FlexCol>
                                  <Text>{value}</Text>
                                  <Text level={6} color='Text3'>
                                    {row?.code} • {dayjs(row?.startDate).format("DD/MM/YYYY")} -{" "}
                                    {dayjs(row?.endDate).format("DD/MM/YYYY")}
                                  </Text>
                                </FlexCol>
                              ),
                            };
                          },
                        },
                        {
                          title: "ประเภทส่วนลด",
                          dataIndex: "type",
                          key: "type",
                          render: (value: any, row: any, index: number) => {
                            return {
                              children: (
                                <FlexCol>
                                  <Tag
                                    style={{
                                      backgroundColor: `${row?.creditMemoType?.color}20`,
                                      border: "none",
                                    }}
                                  >
                                    <Typography.Text
                                      style={{
                                        color: row?.creditMemoType?.color,
                                        fontFamily: "IBM Plex Sans Thai",
                                        fontSize: 15,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {row?.creditMemoType?.code} • {row?.creditMemoType?.nameTh}
                                    </Typography.Text>
                                  </Tag>
                                </FlexCol>
                              ),
                            };
                          },
                        },
                        {
                          title: "วิธีคิดส่วนลด",
                          dataIndex: "type",
                          key: "type",
                          render: (value: any, row: any, index: number) => {
                            return {
                              children: (
                                <FlexCol>
                                  <Text>
                                    {value === "BILL_PCT" ? "% ของยอดบิล" : "บาท (฿)/หน่วย"}
                                  </Text>
                                </FlexCol>
                              ),
                            };
                          },
                        },
                        {
                          title: "ส่วนลด",
                          dataIndex: "type",
                          key: "type",
                          hidden: coType !== "SKU",
                          render: (value: any, row: any, index: number) => {
                            return {
                              children: (
                                <FlexCol>
                                  <Text>{row.products.length} รายการสินค้า</Text>
                                </FlexCol>
                              ),
                            };
                          },
                        },
                      ]}
                      dataSource={item || []}
                      rowKey={(record: any) => record.id || record.code || record.name}
                      expandable={{
                        expandedRowRender: (record: any) => {
                          return (
                            <>
                              {(record?.products || []).map((product: any) => (
                                <div
                                  style={{
                                    borderLeft: `4px solid ${record?.creditMemoType?.color}`,
                                  }}
                                  key={product.product.productId}
                                >
                                  <Row justify={"start"} gutter={8}>
                                    <>
                                      <Col span={2} />
                                      <Col style={{ paddingTop: "20px" }}>
                                        <EnterOutlined
                                          style={{
                                            transform: "scaleY(-1)  rotate(180deg)",
                                            fontSize: "25px",
                                          }}
                                        />
                                      </Col>
                                      <Col span={2} style={{ paddingTop: "8px" }}>
                                        <div style={{ marginRight: 16 }}>
                                          <Avatar
                                            src={
                                              product.product.productImage === "No" ||
                                              product.product.productImage === "" ||
                                              product.product.productImage === null
                                                ? image.product_no_image
                                                : product.product.productImage
                                            }
                                            size={50}
                                            shape='square'
                                            onError={() => false}
                                          />
                                        </div>
                                      </Col>
                                      <Col span={8}>
                                        <div style={{ height: 25, textOverflow: "ellipsis" }}>
                                          <Text level={5}>{product.product.productName}</Text>
                                        </div>
                                        {product.product.commonName && (
                                          <div style={{ height: 25, textOverflow: "ellipsis" }}>
                                            <Text level={6} style={{ color: color.Grey }}>
                                              {product.product.commonName}
                                            </Text>
                                          </div>
                                        )}
                                        <div style={{ height: 25 }}>
                                          <Text level={6} style={{ color: color.Grey }}>
                                            Product Group : {product.product.productGroup}
                                          </Text>
                                        </div>
                                        {product.product.productStrategy && (
                                          <div style={{ height: 25 }}>
                                            <Text level={6} style={{ color: color.Grey }}>
                                              Strategy Group : {product.product.productStrategy}
                                            </Text>
                                          </div>
                                        )}
                                      </Col>
                                    </>
                                    <Col span={5}>
                                      <div style={{ height: 25 }}>
                                        <Text level={5}>{product.product.productCodeNAV}</Text>
                                      </div>
                                      <div
                                        style={{
                                          height: 25,
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        <Text level={6} style={{ color: color.Grey }}>
                                          Pack Size : {product.product.packSize}
                                        </Text>
                                      </div>
                                    </Col>
                                    <Col span={4}>
                                      <Text level={5}>
                                        ลด {numberFormatter(product.discountValue)} ฿/หน่วย
                                      </Text>
                                    </Col>
                                  </Row>
                                </div>
                              ))}
                            </>
                          );
                        },
                        rowExpandable: (record: any) => (record?.products || []).length > 0,
                        defaultExpandAllRows: true,
                        showExpandColumn: false,
                      }}
                      pagination={false}
                    />
                  </ConfigProvider>
                </div>
              </React.Fragment>
            ))}
          </>
        )}
      </>
    </Modal>
  );
};

export const ChangeStatusShopModal = ({
  coId,
  coShopId,
  open,
  setOpen,
  status,
  cusName,
  isShowDealer,
  fetchData,
}: {
  coId: string;
  coShopId?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  status: string;
  cusName: string;
  isShowDealer: boolean;
  fetchData?: () => void;
}) => {
  const { messageApi } = useMessageContext();
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const [formRemark] = Form.useForm();
  const _watchRemarkSale = Form.useWatch("remarkSale", formRemark);
  const _watchRemarkDealer = Form.useWatch("remarkDealer", formRemark);

  const optionSaleFer = [
    { key: "ร้านค้าขายข้ามเขต", value: "ร้านค้าขายข้ามเขต", label: "ร้านค้าขายข้ามเขต" },
    {
      key: "มีปัญหาเรื่องการชำระเงินกับบริษัท",
      value: "มีปัญหาเรื่องการชำระเงินกับบริษัท",
      label: "มีปัญหาเรื่องการชำระเงินกับบริษัท",
    },
    {
      key: "อื่นๆ",
      value: "อื่นๆ",
      label: "อื่นๆ",
    },
  ];

  const optionDealerFer = [
    { key: "ทำผิดนโยบายบริษัท", value: "ทำผิดนโยบายบริษัท", label: "ทำผิดนโยบายบริษัท" },
    {
      key: "อื่นๆ",
      value: "อื่นๆ",
      label: "อื่นๆ",
    },
  ];

  const onFinish = async () => {
    const mapSaleRemark =
      formRemark.getFieldValue("remarkSale") === "อื่นๆ"
        ? formRemark.getFieldValue("remarkSaleOther")
        : formRemark.getFieldValue("remarkSale");
    const mapDealerRemark =
      formRemark.getFieldValue("remarkDealer") === "อื่นๆ"
        ? formRemark.getFieldValue("remarkDealerOther")
        : formRemark.getFieldValue("remarkDealer");
    const payload = {
      coId: coId,
      status: status === "เปิดใช้งาน" ? "ACTIVE" : "INACTIVE",
      saleRemarkText: mapSaleRemark || undefined,
      dealerRemarkText: mapDealerRemark || undefined,
      updateBy: profile?.firstname + " " + profile?.lastname,
    };
    if (!coShopId) {
      await updateStatusMainWithRemark(payload).then((res) => {
        if (res.success) {
          messageApi.success(`เปลี่ยนสถานะสำเร็จ`);
          setOpen(false);
          fetchData && fetchData();
        }
      });
    } else {
      payload["coShopId"] = coShopId;
      await updateStatusShopWithRemark(payload).then((res) => {
        if (res.success) {
          messageApi.success(`เปลี่ยนสถานะสำเร็จ`);
          setOpen(false);
          fetchData && fetchData();
        }
      });
    }
  };

  return (
    <>
      <Modal
        maskClosable={false}
        open={open}
        onCancel={() => setOpen(false)}
        centered
        okText='บันทึก'
        cancelButtonProps={{ style: { color: color.primary, borderColor: color.primary } }}
        onOk={async () => {
          try {
            await formRemark.validateFields();
            onFinish();
            //setOpen(false);
          } catch (error) {
            console.log("error remark", error);
          }
        }}
      >
        <Text fontWeight={600} level={4}>
          {cusName ? `ระบุหมายเหตุ${status} ${cusName}` : ""}
        </Text>
        <Form form={formRemark} layout='vertical' style={{ paddingTop: "16px" }}>
          <Form.Item
            name='remarkSale'
            label='หมายเหตุถึง Sale'
            rules={[
              {
                required: true,
                message: "*โปรดเลือกหมายเหตุถึง Sale",
              },
            ]}
          >
            <Select
              allowClear
              options={optionSaleFer}
              placeholder='ระบุหมายเหตุ Sale'
              style={{ width: "100%", height: "40px" }}
            />
          </Form.Item>
          {_watchRemarkSale === "อื่นๆ" && (
            <Form.Item
              name='remarkSaleOther'
              rules={[
                {
                  required: _watchRemarkSale === "อื่นๆ",
                  message: "*โปรดระบุหมายเหตุอื่นๆ",
                },
              ]}
            >
              <Input
                placeholder='ระบุหมายเหตุของคุณ'
                style={{ width: "100%", height: "40px" }}
                autoComplete='off'
              />
            </Form.Item>
          )}
          {isShowDealer && (
            <>
              <Form.Item
                name='remarkDealer'
                label='หมายเหตุถึง Dealer'
                rules={[
                  {
                    required: true,
                    message: "*โปรดเลือกหมายเหตุถึง Dealer",
                  },
                ]}
              >
                <Select
                  allowClear
                  options={optionDealerFer}
                  placeholder='ระบุหมายเหตุ Dealer'
                  style={{ width: "100%", height: "40px" }}
                />
              </Form.Item>
              {_watchRemarkDealer === "อื่นๆ" && (
                <Form.Item
                  name='remarkDealerOther'
                  rules={[
                    {
                      required: _watchRemarkDealer === "อื่นๆ",
                      message: "*โปรดระบุหมายเหตุอื่นๆ",
                    },
                  ]}
                >
                  <Input
                    placeholder='ระบุหมายเหตุของคุณ'
                    style={{ width: "100%", height: "40px" }}
                    autoComplete='off'
                  />
                </Form.Item>
              )}
            </>
          )}
        </Form>
      </Modal>
    </>
  );
};

export const ConfirmChangeStatusModal = ({
  modalConfirmDup,
  setModalConfirmDup,
  modalDuplicate,
  setModalDuplicate,
  onFinish,
}: {
  modalConfirmDup: any;
  setModalConfirmDup: (modalConfirmDup: any) => void;
  modalDuplicate: any;
  setModalDuplicate: (modalDuplicate: any) => void;
  onFinish?: () => void;
}) => {
  return (
    <>
      <Modal
        open={modalConfirmDup.open}
        maskClosable={false}
        onCancel={() => setModalConfirmDup((prev) => ({ open: false }))}
        footer={null}
        centered
        width={600}
      >
        <Row justify='center'>
          <img src={image?.errorState} alt='Error State' style={{ height: "90px" }} />
        </Row>
        <Row justify='center'>
          <Text level={4} fontWeight={600}>
            มีร้านค้ากำลังใช้งานส่วนลดอื่นอยู่
          </Text>
        </Row>
        <Row justify='center'>
          <Col style={{ textAlign: "center" }}>
            {modalConfirmDup.isBlocking ? (
              <Text color='Text3'>
                ร้านค้าที่กำลังใช้งานส่วนลดอื่นอยู่จะไม่ถูกเปิดทำงาน <br />
                เนื่องจากไม่สามารถเปิดส่วนลด ประเภท % ของยอดบิล ซ้อนกันได้ <br /> <br />
                คุณยังสามารถเพิ่มร้านนี้ไว้ในรายการได้ หากต้องการให้ร้านนี้เริ่มใช้ส่วนลดนี้ <br />
                กรุณาปิดใช้งานรายการเดิมของร้านนั้นก่อน
              </Text>
            ) : (
              <Text color='Text3'>
                ซึ่งอาจทำให้ส่วนลดทำงานทับซ้อนกันได้ <br /> คุณสามารถเปิดใช้งานรายการนี้ต่อได้ทันที
                หากคุณไม่ต้องการให้ร้านค้าได้รับ <br /> ส่วนลดซ้อนกัน
                กรุณาตรวจสอบและปิดใช้งานรายการเดิมของร้านนั้นก่อน
              </Text>
            )}
          </Col>
        </Row>
        <br />
        <Row justify='space-between' gutter={8}>
          <Col span={modalConfirmDup.countShop > modalConfirmDup.countBlocking ? 12 : 24}>
            <Button
              typeButton='primary-light'
              title='ตรวจสอบร้านค้า'
              onClick={() =>
                setModalDuplicate({
                  data: modalConfirmDup.data,
                  open: true,
                  isStatus: modalConfirmDup?.isBlocking,
                })
              }
            />
          </Col>
          {modalConfirmDup.countShop > modalConfirmDup.countBlocking && (
            <Col span={12}>
              <Button typeButton='primary' title='เปิดใช้งานส่วนลด' onClick={onFinish} />
            </Col>
          )}
        </Row>
      </Modal>
      {modalDuplicate.open && (
        <DetailDuplicateModal
          dataDup={modalDuplicate.data}
          open={modalDuplicate.open}
          setOpen={(open) => setModalDuplicate((prev) => ({ ...prev, open }))}
          isStatus={modalDuplicate.isStatus}
        />
      )}
    </>
  );
};

export const readFileAsBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result ?? ""));
    reader.onerror = () => reject(new Error("Cannot read file"));
    reader.readAsDataURL(file);
  });

export const ModalPreviewFile: React.FC<{
  openPdf: boolean;
  setOpenPdf: (open: boolean) => void;
  fileRef?: any;
}> = ({ openPdf, setOpenPdf, fileRef }) => {
  return (
    <Modal open={openPdf} onCancel={() => setOpenPdf(false)} footer={null} width={900} centered>
      <iframe
        src={fileRef}
        width='100%'
        height='600'
        style={{ border: "none" }}
        title='PDF Preview'
      />
    </Modal>
  );
};

export const ModalPreviewImg: React.FC<{
  openImg: boolean;
  setOpenImg: () => void;
  imgRef?: any;
}> = ({ openImg, setOpenImg, imgRef }) => {
  return (
    <Modal
      key={imgRef}
      open={openImg}
      onCancel={() => setOpenImg()}
      footer={null}
      width={800}
      height={500}
      centered
    >
      <Image src={imgRef || undefined} width='100%' />
    </Modal>
  );
};

export const EXPAND_MOTION_DURATION = 280;

export const ExpandInvoiceRow = ({
  record,
  company,
  collapsing = false,
  instant = false,
}: {
  record: any;
  company: string;
  collapsing?: boolean;
  instant?: boolean;
}) => {
  const [openPdf, setOpenPdf] = useState(false);
  const [previewFile, setPreviewFile] = useState<string | undefined>(undefined);
  const [open, setOpen] = useState(instant);

  useEffect(() => {
    if (!collapsing || !open) {
      return;
    }
    const frame = requestAnimationFrame(() => setOpen(false));
    return () => cancelAnimationFrame(frame);
  }, [collapsing, open]);

  useEffect(() => {
    if (collapsing || open) {
      return;
    }
    let innerFrame = 0;
    const frame = requestAnimationFrame(() => {
      innerFrame = requestAnimationFrame(() => setOpen(true));
    });
    return () => {
      cancelAnimationFrame(frame);
      cancelAnimationFrame(innerFrame);
    };
  }, [collapsing, open]);

  const onDownload = async (invNo: string, company: string) => {
    const token = localStorage.getItem("token") || "";
    const headers = {
      "Content-Type": "blob",
      Authorization: token ? `Bearer ` + JSON.parse(token) : "",
    };
    const config: AxiosRequestConfig = {
      method: "GET",
      url: `https://system.icpladda.com/api/invoice/download?invNo=${invNo}&company=${company}`,
      responseType: "arraybuffer",
      headers,
      params: { invNo, company },
    };
    const response = await axios(config);

    const file = new Blob([response.data], {
      // type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      type: "application/pdf",
    });

    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `invoice-${invNo}-${new Date().toISOString().split("T")[0]}.pdf`);

    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
  };

  const onPreviewInvoice = async (invNo: string, company: string): Promise<void> => {
    try {
      const tokenFromStorage = localStorage.getItem("token");
      const token = tokenFromStorage ? JSON.parse(tokenFromStorage) : "";
      const config: AxiosRequestConfig = {
        method: "GET",
        url: "https://system.icpladda.com/api/invoice/download",
        responseType: "blob",
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
        params: { invNo, company },
      };
      const response = await axios(config);
      const pdfBlob = response.data as Blob;
      const previewUrl = window.URL.createObjectURL(pdfBlob);
      setPreviewFile(previewUrl);
      setOpenPdf(true);
    } catch (error: unknown) {
      console.error("Error fetching invoice PDF:", error);
    }
  };

  const content = (
    <>
      <Row justify={"start"} gutter={8} key={record?.coId}>
        <Col span={4} />
        <Col span={20}>
          <Row justify={"space-between"} gutter={8}>
            <Col span={6}>
              <Text level={4} fontWeight={600}>
                วันที่
              </Text>
            </Col>
            <Col span={6}>
              <Text level={4} fontWeight={600}>
                เลขที่เอกสาร
              </Text>
            </Col>
            <Col span={6}>
              {record?.coType === "SKU" && (
                <Text level={4} fontWeight={600}>
                  ส่วนลด (บาท)
                </Text>
              )}
            </Col>
            <Col span={6} />
          </Row>
        </Col>
      </Row>
      {record?.invoices?.map((invoice: any, index: number) => (
        <>
          <Row justify={"start"} gutter={8} key={index}>
            <Col span={4} />
            <Col span={20}>
              <Row justify={"space-between"} gutter={8}>
                <Col span={6}>
                  <Text>{dayjs(invoice.date).format("DD/MM/YYYY")}</Text>
                </Col>
                <Col span={6}>
                  <Text
                    color='primary'
                    style={{ cursor: "pointer" }}
                    onClick={() => onPreviewInvoice(invoice.invoiceNo, company)}
                  >
                    <u>{invoice.invoiceNo}</u>
                  </Text>
                </Col>
                <Col span={6}>
                  {record?.coType === "SKU" && (
                    <Text color={invoice.coAmt > 0 ? "error" : "Text1"}>
                      {invoice.coAmt > 0 ? numberFormatter(invoice.coAmt) : 0} ฿
                    </Text>
                  )}
                </Col>
                <Col span={6} />
              </Row>
            </Col>
          </Row>
          {openPdf && (
            <ModalPreviewFile openPdf={openPdf} setOpenPdf={setOpenPdf} fileRef={previewFile} />
          )}
        </>
      ))}
    </>
  );

  return (
    <div
      className={`co-expand-motion${open ? " co-expand-motion-open" : ""}`}
      style={{ transitionDuration: `${EXPAND_MOTION_DURATION}ms` }}
    >
      <div className='co-expand-motion-inner'>
        <div className='co-expand-motion-content'>{content}</div>
      </div>
    </div>
  );
};

export const useSmoothExpandedRows = (duration: number = EXPAND_MOTION_DURATION) => {
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);
  const [collapsingKeys, setCollapsingKeys] = useState<string[]>([]);
  const timers = useRef<Record<string, ReturnType<typeof setTimeout>>>({});
  const settledKeys = useRef<Set<string>>(new Set());

  useEffect(() => {
    settledKeys.current = new Set(expandedRowKeys.map((key) => String(key)));
  }, [expandedRowKeys]);

  useEffect(
    () => () => {
      Object.values(timers.current).forEach((timer) => clearTimeout(timer));
      timers.current = {};
    },
    [],
  );

  const onExpand = (isExpanded: boolean, record: any) => {
    const rowKey = String(record?.rowKey ?? "");

    if (timers.current[rowKey]) {
      clearTimeout(timers.current[rowKey]);
      delete timers.current[rowKey];
    }

    if (isExpanded) {
      setCollapsingKeys((prev) => prev.filter((key) => key !== rowKey));
      setExpandedRowKeys((prev) => (prev.includes(rowKey) ? prev : [...prev, rowKey]));
      return;
    }

    setCollapsingKeys((prev) => (prev.includes(rowKey) ? prev : [...prev, rowKey]));
    timers.current[rowKey] = setTimeout(() => {
      delete timers.current[rowKey];
      setExpandedRowKeys((prev) => prev.filter((key) => key !== rowKey));
      setCollapsingKeys((prev) => prev.filter((key) => key !== rowKey));
    }, duration);
  };

  const isCollapsing = (record: any) => collapsingKeys.includes(String(record?.rowKey ?? ""));

  const isSettled = (record: any) => settledKeys.current.has(String(record?.rowKey ?? ""));

  return { expandedRowKeys, collapsingKeys, isCollapsing, isSettled, onExpand };
};

export const useInvoiceExpandable = (company: string) => {
  const { expandedRowKeys, isCollapsing, isSettled, onExpand } = useSmoothExpandedRows();

  return {
    expandedRowKeys,
    onExpand,
    expandedRowClassName: () => "co-expand-row",
    expandedRowRender: (record: any) => {
      return record?.invoices?.length > 0 ? (
        <ExpandInvoiceRow
          record={record}
          company={company}
          collapsing={isCollapsing(record)}
          instant={isSettled(record)}
        />
      ) : null;
    },
    rowExpandable: (record: any) => (record?.invoices?.length ?? 0) > 0,
    expandIcon: ({ expanded, onExpand: toggleExpand, record }: any) => {
      const hasInvoices = (record?.invoices?.length ?? 0) > 0;
      if (!hasInvoices) {
        return null;
      }
      const isOpen = expanded && !isCollapsing(record);
      return (
        <DownOutlined
          className={`co-expand-icon${isOpen ? " co-expand-icon-open" : ""}`}
          onClick={(event) => toggleExpand(record, event)}
        />
      );
    },
  };
};
